module.exports = __webpack_public_path__ + "img/manage03.f7d8a13c.png";